<div class="px-px-24 py-px-1" style="background: #F3F8FA;">
    <div class="d-flex align-items-center justify-content-between my-3">
        <h1 style="margin: 0;">Affectation directe des missions</h1>
    </div>

    <div class="d-flex align-items-center justify-content-between my-3 flex-wrap">
        <div class="d-flex align-items-center">
            <div class="me-4 inner-add-on left-add-on my-3">
                <input type="search" class="form-control w-px-400" (input)="searchItem($event)"
                    placeholder="Rechercher une mission non affectée" />
                <svg-icon class="inner-icon left" svgClass="placeholder-icon"
                    src="/assets/icons/search-grey.svg"></svg-icon>
            </div>
        </div>
        <div class="card-container p-px-8 quick-filter-etablissements" *ngIf="siteList.length">
            @for (item of siteList; track item.id) {
            <app-filter-tag [text]="item.name" bgColor="white" color="white" [chipSelected]="selectedSite === item.id"
                (handleClick)="toggleSelectSite($event, item)"></app-filter-tag>
            }
        </div>
    </div>

    <app-data-table [isLoading]="isLoading" [dataSource]="missionListFiltered" [columns]="customColumns"
        [hasRowAction]="false" [showSideBar]="true" [component]="component" [totalItems]="totalItems"
        (nextPage)="pagination($event)" [pageSize]="size" [pageIndex]="offset"></app-data-table>
</div>